const discover = {
  "discover.page_title": "ทำความรู้จัก Define®​",
  "discover.trait_01.body": "ผนึกชั้นสีในชั้นเลนส์อย่างปลอดภัย ทำให้สีไม่สัมผัสกับดวงตาโดยตรง",
  "discover.trait_01.title": "เทคโนโลยี <em>Beauty Wrapped In Comfort™ </em>",
  "discover.trait_02.body": "ป้องกันรังสียูวีในคอนแทคเลนส์* <br />​ (ป้องกันรังสี UVA 81% และ UVB 97%)​​",
  "discover.trait_02.title": "ป้องกันรังสียูวีตลอดวัน*",
  "discover.trait_03.body": "ผสมผสานสามเลเยอร์ของชั้นสีด้วยการวาดลายเส้น ทำให้ดวงตาดูมีมิติ เป็นธรรมชาติ",
  "discover.trait_03.title": "เทคนิคการซ้อนเลเยอร์สี 3 ชั้น",
  "discover.trait_04.item_01.body": "ออกแบบขอบเลนส์ให้โค้งรับเข้ากับดวงตาของคุณ",
  "discover.trait_04.item_01.title": "ขอบเลนส์",
  "discover.trait_04.item_02.body": "มอบความชุ่มชื้นให้ดวงตาด้วยเทคโนโลยีพิเศษ กักเก็บความชุ่มชื้นสบายตาตลอดวัน**",
  "discover.trait_04.item_02.title": "ความชุ่มชื้นของเลนส์",
  "discover.trait_04.item_03.body": "เลนส์โอบรับดวงตาอย่างเหมาะสม เพื่อให้ดวงตาสบายมากขึ้น",
  "discover.trait_04.item_03.title": "ความยืดหยุ่นของเลนส์",
  "discover.trait_04.title": "ดีไซน์เพื่อดวงตา ใส่สบายตาตลอดวัน**​",
}

export const try_lenses = {
  "try_lenses.block_title": "ลองเลนส์ <span>ACUVUE® Define® </span> เสมือนจริง",
  "try_lenses.virtual_mirror": "Filter ลองเลนส์",
}

export const product_range = {
  "product_range.block_title": "ค้นหาเลนส์ <span>ACUVUE® Define®</span> ที่ใช่สำหรับคุณ",
  "product_range.button.classic": "ทำความรู้จัก Define® Classic",
  "product_range.button.fresh": "ทำความรู้จัก Define® Fresh ",
}

const discover_references = {
  "discover_references": "<h1>REFERENCES/ DISCLAIMER</h1> <p> ** LACREON* Technology is Johnson & Johnson Vision Care, Inc.'s brand name for its proprietary technology that permanently embeds a water-holding ingredient, similar to that found in natural tears, into the proven etafilcon A material. </p> <h1>Important information for contact lens wearers</h1> <p>ACUVUE® Brand Contact Lenses are available by prescription only for vision correction. An eye care professional will determine whether contact lenses are right for you. Although rare, serious eye problems can develop while wearing contact lenses. To help avoid these problems, follow the wear and replacement schedule and the lens care instructions provided by your eye doctor. Do not wear contact lenses if you have an eye infection, or experience eye discomfort, excessive tearing, vision changes, redness or other eye problems. If one of these conditions occurs, contact your eye doctor immediately. For more information on proper wear, care and safety, talk to your Eye Care Professional or refer to ACUVUE®'s <a href=\"https://www.acuvue.com.my/patient-instruction-guides?_gl=1%2A5j622a%2A_ga%2AMTY3MjYyODQ5MC4xNzA5NzA2Mzk2%2A_ga_V5PVFGQ8H6%2AMTcwOTcwNjM5NS4xLjAuMTcwOTcwNjM5NS42MC4wLjA\"> Patient Instruction Guide</a>. </p>"
}


// export default discover;
export default {
  ...discover,
  ...try_lenses,
  ...product_range,
  ...discover_references
}






